export default function handleAnalyticsClicks() {
    $('body').on('click', 'a[href^="mailto:"]', function (e) {
        return gtag_report_mail_conversion($(this).attr('href'));
    }).on('click', 'a[href^="tel:"]', function () {
        gtag_report_tel_conversion($(this).attr('href'));
    }).on('click', 'a[href$="/get-a-quote/"]', function (e) {
        let href = $(this).attr('href');
        return gtag_report_url_click('quote-click', href);
    }).on('click', 'a[href$="/quiz/"]', function (e) {
        let href = $(this).attr('href');
        return gtag_report_url_click('quiz-click', href);
    }).on('click', 'a[href*="/products/"]', function (e) {
        let href = $(this).attr('href');
        return gtag_report_url_click('product-click', href, {'product-url': href});
    });
}

function gtag_report_url_click(event, url, data = {}) {
    try {
        let eventData = $.extend({
            'event': event, 'eventCallback': function () {
                window.location.href = url;
            }
        }, {}, data);
        dataLayer.push(eventData);
    } catch (e) {
        window.location.href = url;
    }
    return false;
}

function gtag_report_mail_conversion(url) {
    console.log('report mail');
    try {
        dataLayer.push({
            'event': 'email-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
        window.location.href = url;
    }
    return false;
}

function gtag_report_tel_conversion(url) {
    console.log('report tel');
    try {
        dataLayer.push({'event': 'phone-click'});
    } catch (e) {
        window.location.href = url;
    }
}
